var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1H7V2H3V1ZM2 3V2H3V3H2ZM2 7H1V3H2V7ZM3 8H2V7H3V8ZM7 8V9H3V8H7ZM8 7H7V8H8V9H9V10H10V11H11V10H10V9H9V8H8V7ZM8 3H9V7H8V3ZM8 3V2H7V3H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchS);
export default __webpack_public_path__ + "static/media/search-s.e117e8bcd8b9ff45df115ab781e71dbf.svg";
export { ForwardRef as ReactComponent };